module.exports = __webpack_public_path__ + "static/media/logo3.71a612df.jpg";